import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { cn } from '@/lib/utils';

interface MarkdownProps {
  children: string;
  className?: string;
}

export function Markdown({ children, className }: MarkdownProps) {
  return (
    <div className={cn('text-sm leading-relaxed text-foreground', className)}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          p: ({ children: c, ...props }) => (
            <p className="my-3 first:mt-0 last:mb-0" {...props}>
              {c}
            </p>
          ),
          h1: ({ children: c, ...props }) => (
            <h1 className="mb-3 mt-6 text-xl font-semibold first:mt-0" {...props}>
              {c}
            </h1>
          ),
          h2: ({ children: c, ...props }) => (
            <h2 className="mb-3 mt-6 text-lg font-semibold first:mt-0" {...props}>
              {c}
            </h2>
          ),
          h3: ({ children: c, ...props }) => (
            <h3 className="mb-2 mt-5 text-base font-semibold first:mt-0" {...props}>
              {c}
            </h3>
          ),
          ul: ({ children: c, ...props }) => (
            <ul className="my-3 list-disc space-y-1.5 pl-5" {...props}>
              {c}
            </ul>
          ),
          ol: ({ children: c, ...props }) => (
            <ol className="my-3 list-decimal space-y-1.5 pl-5" {...props}>
              {c}
            </ol>
          ),
          li: ({ children: c, ...props }) => (
            <li className="leading-relaxed" {...props}>
              {c}
            </li>
          ),
          hr: (props) => <hr className="my-6 border-border" {...props} />,
          strong: ({ children: c, ...props }) => (
            <strong className="font-semibold" {...props}>
              {c}
            </strong>
          ),
          blockquote: ({ children: c, ...props }) => (
            <blockquote
              className="my-3 border-l-2 border-border pl-3 italic text-muted-foreground"
              {...props}
            >
              {c}
            </blockquote>
          ),
          code: ({ children: c, ...props }) => (
            <code
              className="rounded bg-muted px-1 py-0.5 font-mono text-[0.85em]"
              {...props}
            >
              {c}
            </code>
          ),
          a: ({ href, children: linkChildren, ...props }) => (
            <a
              href={href}
              target="_blank"
              rel="noreferrer"
              className="text-capitol-red-600 underline hover:text-capitol-red-700"
              {...props}
            >
              {linkChildren}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
